var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "smart-dialog",
          attrs: {
            title: _vm.$i18.language("创建商机列表"),
            "close-on-click-modal": false,
            "append-to-body": false,
            visible: _vm.dialogVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "smartform",
              staticClass: "smart-form",
              attrs: { model: _vm.params, rules: _vm.rules },
            },
            [
              _c("el-form-item", { attrs: { prop: "title" } }, [
                _c("p", { staticClass: "label" }, [
                  _vm._v(" " + _vm._s(_vm.$t("tableHeader.listName")) + "： "),
                ]),
                _c(
                  "div",
                  [
                    _c("el-input", {
                      attrs: { maxlength: 100, clearable: "" },
                      model: {
                        value: _vm.params.title,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "title", $$v)
                        },
                        expression: "params.title",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("el-form-item", { attrs: { prop: "searchType" } }, [
                _c("p", { staticClass: "label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$i18.language(
                        "将当前查询结果中的采/供应商保存入列表中"
                      )
                    ) + "："
                  ),
                ]),
                _c(
                  "div",
                  {},
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "smart-business-select",
                        attrs: {
                          "popper-class": "customer-select",
                          placeholder: "",
                        },
                        model: {
                          value: _vm.params.searchType,
                          callback: function ($$v) {
                            _vm.$set(_vm.params, "searchType", $$v)
                          },
                          expression: "params.searchType",
                        },
                      },
                      _vm._l(_vm.searchTypes, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("el-form-item", { attrs: { prop: "sortType" } }, [
                _c("p", { staticClass: "label" }, [
                  _vm._v(
                    _vm._s(_vm.$i18.language("为智能列表新增排序方式")) + "："
                  ),
                ]),
                _c(
                  "div",
                  {},
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "smart-business-select",
                        attrs: {
                          "popper-class": "customer-select",
                          placeholder: "",
                        },
                        model: {
                          value: _vm.params.sortType,
                          callback: function ($$v) {
                            _vm.$set(_vm.params, "sortType", $$v)
                          },
                          expression: "params.sortType",
                        },
                      },
                      _vm._l(_vm.sortTypes, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("el-form-item", { attrs: { prop: "sortType" } }, [
                _c(
                  "p",
                  { staticClass: "label" },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$i18.language("自动加入符合查询条件企业")) +
                          "："
                      ),
                    ]),
                    _c("el-switch", {
                      model: {
                        value: _vm.params.autoJoin,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "autoJoin", $$v)
                        },
                        expression: "params.autoJoin",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "smart-business-tips" }, [
            _c("p", [_vm._v(_vm._s(_vm.$i18.language("注意：")))]),
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.$i18.language(
                    "1、商机列表中，新增的排序方式需要在创建之后的24小时之后生效。"
                  )
                )
              ),
            ]),
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.$i18.language(
                    "2、开启自动加入查询条件企业时，系统还将单独列出当前自然月中新增企业。"
                  )
                )
              ),
            ]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "sub-confirm-btn",
                  attrs: { size: "mini" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              ),
              _c(
                "el-button",
                {
                  staticClass: "confirm-btn",
                  attrs: { size: "mini" },
                  on: { click: _vm.confirm },
                },
                [_vm._v(_vm._s(_vm.$t("sure")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }